import { Component, Input } from '@angular/core';

// Inline progress bar with auto-coloured fill (top/mid/low) based
// on percentage. Two visual sizes:
//   - 'mini'   = compact bar used in My Tangrams + overview rows
//   - 'inline' = full bar used in content metrics & engagement tables
@Component({
  selector: 'tangram-analytics-completion-bar',
  templateUrl: './analytics-completion-bar.component.html',
  styleUrls: ['./analytics-completion-bar.component.scss']
})
export class AnalyticsCompletionBarComponent {
  @Input() percent = 0;
  @Input() variant: 'mini' | 'inline' = 'inline';
  @Input() forceTone: 'top' | 'mid' | 'low' | null = null;
  @Input() topThreshold = 70;
  @Input() midThreshold = 40;

  get tone(): 'top' | 'mid' | 'low' {
    if (this.forceTone) { return this.forceTone; }
    if (this.percent >= this.topThreshold) { return 'top'; }
    if (this.percent >= this.midThreshold) { return 'mid'; }
    return 'low';
  }
}
